import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ValidacaoScr } from 'src/app/model/validacao-scr.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';
import { TIPOS_VALIDACAO_ARQ_SCR} from 'src/app/model/validacao-scr.model';


@Component({
    selector: 'app-validacao-scr-listagem',
    templateUrl: './validacao-scr-listagem.component.html',
    styleUrls: ['./validacao-scr-listagem.component.scss'],
    standalone: false
})
export class ValidacaoScrListagemComponent implements OnInit {
  
  tiposValidacaoScr = TIPOS_VALIDACAO_ARQ_SCR;

  private agentesFinanceiros: AgenteFinanceiro[] = [];

  @Input() public validacoesScr: ValidacaoScr[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;  
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();

  constructor( private activatedRoute: ActivatedRoute,) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
  }

  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  public ngOnInit() {
    if (!this.atributosPaginacao) {
      this.atributosPaginacao = <any> {};
    }
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valorEstimadoHonra') {
      funcao = parseFloat;
    }
    this.validacoesScr = this.validacoesScr.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  private nomeAgente(cnpj: string) {
    return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
  }

  private labelTipoValidacaoScr(codigo: string): string {
    return this?.tiposValidacaoScr?.find(tipo => tipo.codigo === codigo)?.label;
}
}
